import { getMenuIcon } from "../../icons/menu";
import React, { useState } from 'react';
import classNames from 'classnames';
import LaddaButton, { SLIDE_UP, XL } from 'react-ladda';
import { env } from '../../../env';
import ContactFields from "./payer-contacts";
import HobbyFields from "./payer-hobby";
import SocialFields from "./payer-social";
import GiftsFields from "./payer-gifts";
import DescriptionFields from "./payer-description";
import TransfersFields from "./payer-transfers";



const PayerPageTabs = ({ state, onClose }) => {

    const [tabActive, setTabActive] = useState('contact');
    const [saveButton, setsaveButton] = useState('none');
    const [oldData, setData] = useState({...state.model});


    let onSave = async () => {
        try {
          await env.http.patch(`payer/${state.model.payer_id}/`, JSON.parse(JSON.stringify(oldData)));
          env.alert('Успех', `Данные успешно обновлены`);
          onClose();
        } catch (e) {
          console.error(e);
          env.alert(
            'Ошибка',
            `Ошибка. Данные не обновились.<br /><br /> Тип ошибки: <br />${e.response.data.error_message}`
        );
        }
      };

    let changeName = (e) => {
        setsaveButton('block');
        setData({...oldData, name: e.target.value});
        return
    }

    let setProfession = (e) => {
        setsaveButton('block');
        setData({...oldData, profession: e.target.value});
        return
    }

    let setCity = (e) => {
        setsaveButton('block');
        setData({...oldData, city: e.target.value});
        return
    }

    let setLivingPlaces = (e) => {
        setsaveButton('block');
        setData({...oldData, living_place: e.target.value});
        return
    }

    let setFavoritPlaces = (e) => {
        setsaveButton('block');
        setData({...oldData, favorite_places: e.target.value});
        return
    }

    let setHobby = (e) => {
        setsaveButton('block');
        setData({...oldData, hobby: e.target.value});
        return
    }

    let setSubjectPositive = (e) => {
        setsaveButton('block');
        setData({...oldData, subject_positive: e.target.value});
        return
    }

    let setSubjectNegative = (e) => {
        setsaveButton('block');
        setData({...oldData, subject_negative: e.target.value});
        return
    }

    let setSubjectTriggers = (e) => {
        setsaveButton('block');
        setData({...oldData, subject_triggers: e.target.value});
        return
    }

    let setFriends = (e) => {
        setsaveButton('block');
        setData({...oldData, friends: e.target.value});
        return
    }

    let setChildren = (e) => {
        setsaveButton('block');
        setData({...oldData, children: e.target.value});
        return
    }

    let setParents = (e) => {
        setsaveButton('block');
        setData({...oldData, parents: e.target.value});
        return
    }

    let setWife = (e) => {
        setsaveButton('block');
        setData({...oldData, wife: e.target.value});
        return
    }

    let setAnimal = (e) => {
        setsaveButton('block');
        setData({...oldData, animals: e.target.value});
        return
    }

    let setDescription = (e) => {
        setsaveButton('block');
        setData({...oldData, description: e.target.value});
        return
    }

    let setTransfers = (data) => {
        setData({...oldData, transfers: data});
        return
    }

    let setGift = (e) => {
        setsaveButton('block');
        setData({...oldData, gift: !oldData.gift});
        return
    }

    let setGiftTime = (e) => {
        setsaveButton('block');
        setData({...oldData, gift_time: e.target.value});
        return
    }

    let setGiftSubject = (e) => {
        setsaveButton('block');
        setData({...oldData, gift_subject: e.target.value});
        return
    }

    let setGiftType = (e) => {
        setsaveButton('block');
        setData({...oldData, gift_type: e.target.value});
        return
    }

    let setGiftAmount = (e) => {
        setsaveButton('block');
        setData({...oldData, gift_amount: e.target.value});
        return
    }

    const sideBarElemContactIsActiveClass = classNames('profile-page-sidebar-elem', {
      'profile-page-sidebar-elem--active': tabActive === 'contact'
    });
  
    const sideBarElemIntersestIsActiveClass = classNames('profile-page-sidebar-elem', {
      'profile-page-sidebar-elem--active': tabActive === 'interests'
    });
  
    const sideBarElemSocialActiveClass = classNames('profile-page-sidebar-elem', {
      'profile-page-sidebar-elem--active': tabActive === 'socials'
    });
  
    const sideBarElemGiftsIsActiveClass = classNames('profile-page-sidebar-elem', {
      'profile-page-sidebar-elem--active': tabActive === 'gifts'
    });
  
    const sideBarElemDescriptionIsActiveClass = classNames('profile-page-sidebar-elem', {
      'profile-page-sidebar-elem--active': tabActive === 'descriptions'
    });
  
    const sideBarElemTransfersIsActiveClass = classNames('profile-page-sidebar-elem', {
      'profile-page-sidebar-elem--active': tabActive === 'transfers'
    });

    return (
        <div className='profile-page'>
            <div className='profile-page__container'>
                <div className='profile-page-sidebar'>
                    <div className='profile-page-sidebar__title profile-page__headline-title'>
                        {`Клиент № ${state.model.payer_id}`}
                    </div>
                    <div className='profile-page-sidebar-list'>
                        <div className={sideBarElemContactIsActiveClass} onClick={() => setTabActive('contact')}>
                            <div className='profile-page-sidebar-elem__icon'>
                                {getMenuIcon('card')}
                            </div>
                            <div className='profile-page-sidebar-elem__text'>Контакты</div>
                        </div>

                        <div className={sideBarElemIntersestIsActiveClass} onClick={() => setTabActive('interests')}>
                            <div className='profile-page-sidebar-elem__icon'>
                                {getMenuIcon('card')}
                            </div>
                            <div className='profile-page-sidebar-elem__text'>Интересы</div>
                        </div>

                        <div className={sideBarElemSocialActiveClass} onClick={() => setTabActive('socials')}>
                            <div className='profile-page-sidebar-elem__icon'>
                                {getMenuIcon('card')}
                            </div>
                            <div className='profile-page-sidebar-elem__text'>socials</div>
                        </div>

                        <div className={sideBarElemGiftsIsActiveClass} onClick={() => setTabActive('gifts')}>
                            <div className='profile-page-sidebar-elem__icon'>
                                {getMenuIcon('card')}
                            </div>
                            <div className='profile-page-sidebar-elem__text'>gifts</div>
                        </div>

                        <div className={sideBarElemDescriptionIsActiveClass} onClick={() => setTabActive('descriptions')}>
                            <div className='profile-page-sidebar-elem__icon'>
                                {getMenuIcon('card')}
                            </div>
                            <div className='profile-page-sidebar-elem__text'>descriptions</div>
                        </div>

                        <div className={sideBarElemTransfersIsActiveClass} onClick={() => setTabActive('transfers')}>
                            <div className='profile-page-sidebar-elem__icon'>
                                {getMenuIcon('card')}
                            </div>
                            <div className='profile-page-sidebar-elem__text'>transfers</div>
                        </div>

                        <LaddaButton
                            className='main-form__submit'
                            type='submit'
                            style={{display: saveButton}}
                            data-test-id='submitButton'
                            data-color='#eee'
                            data-size={XL}
                            data-style={SLIDE_UP}
                            data-spinner-size={30}
                            data-spinner-color='#ddd'
                            data-spinner-lines={12}
                            onClick={() => {onSave()}}
                        >
                            Сохранить
                        </LaddaButton>
                    </div>
                </div>

                <div className='profile-page-info-payer'>
                    {tabActive === 'contact' && (
                        <ContactFields 
                        oldData={oldData} 
                        setName={changeName}
                        setProfession={setProfession}
                        setCity={setCity}
                        setLivingPlaces={setLivingPlaces}
                        setFavoritPlaces={setFavoritPlaces}
                        />
                    )}
                    {tabActive === 'interests' && (
                        <HobbyFields 
                        oldData={oldData} 
                        setHobby={setHobby}
                        setSubjectPositive={setSubjectPositive}
                        setSubjectNegative={setSubjectNegative}
                        setSubjectTriggers={setSubjectTriggers}
                        />
                    )}
                    {tabActive === 'socials' && (
                        <SocialFields 
                        oldData={oldData} 
                        setFriends={setFriends}
                        setChildren={setChildren}
                        setParents={setParents}
                        setWife={setWife}
                        setAnimal={setAnimal}
                        />
                    )}
                    {(tabActive === 'gifts') && (
                        <GiftsFields
                        oldData={oldData} 
                        setGift={setGift}
                        setGiftTime={setGiftTime}
                        setGiftSubject={setGiftSubject}
                        setGiftType={setGiftType}
                        setGiftAmount={setGiftAmount}
                        />
                    )}
                    {(tabActive === 'descriptions') && (
                        <DescriptionFields
                        oldData={oldData} 
                        setDescription={setDescription}
                        />
                    )}
                    {(tabActive === 'transfers') && (
                        <TransfersFields
                        oldData={oldData}
                        setTransfers={setTransfers}
                        />
                    )}
                </div>
            </div>
        </div>

    );
}

export default PayerPageTabs;